<template>
  <div class="container">
    <div class="form-wrapper">
      <logo />
      <v-alert v-if="isMerchantClosed" type="error" class="mb-4">
        Merchant Account is closed
      </v-alert>
      <form @submit.prevent="attemptReset">
        <!-- Success message -->
        <div v-if="isSuccess" class="alert alert-success">Check your email!</div>
        <!-- Error message -->
        <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
        <form-input
          name="username"
          label="User Name"
          v-model="username"
          :errors="validationErrors"
          @input="resetResult"
        ></form-input>
        <div class="buttons mt-5">
          <v-col class="text-right pa-0">
            <router-link
              :to="{ name: `login` }"
            >
            Back to Login
            </router-link>
          </v-col>
          <v-col class="text-right pa-0">
          <v-btn color="secondary" type="submit" :disabled="isMerchantClosed">Send password reset link</v-btn>
          </v-col>
        </div>
      </form>
    </div>
    <LoadingModal loadingText="Validating Username..." :showModal="isSubmitting" />
  </div>
</template>
<style scoped>
@media only screen and (max-width:575px){
.v-btn:not(.v-btn--round).v-size--default{margin-top:10px;}
.buttons {display: block;}
}
.alert {
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}
.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
</style>
<script>
import auth from '@/common/auth';
import FormInput from '@/common/components/forms/Input.vue';
import Logo from '@/common/components/Logo.vue';
import LoadingModal from '@/common/components/LoadingModal.vue';
import { MerchantStatus } from '@/iso/views/merchants/merchants.types';

const RESULT_NONE = 0;
const RESULT_SUCCESS = 1;

export default {
  title: 'Reset your password',
  data() {
    return {
      result: RESULT_NONE,
      username: '',
      validationErrors: {},
      isSubmitting: false,
      errorMessage: '',
    };
  },
  computed: {
    isSuccess() {
      return this.result === RESULT_SUCCESS;
    },
    isMerchantClosed() {
      return this.$store.state.branding?.merchantStatus === MerchantStatus.CLOSED;
    },
  },
  methods: {
    attemptReset() {
      this.isSubmitting = true;
      this.resetResult();
      this.errorMessage = '';
      auth
        .post('password/email', {
          username: this.username,
        })
        .then(this.showSuccess)
        .catch(this.showError);
    },
    showSuccess() {
      this.isSubmitting = false;
      this.result = RESULT_SUCCESS;
    },
    showError({ response }) {
      this.isSubmitting = false;
      this.validationErrors = response?.data?.errors || {};

      if (response?.data?.message) {
        this.errorMessage = response.data.message;
      } else {
        this.errorMessage = 'An unexpected error occurred. Please try again.';
      }
    },
    resetResult() {
      this.result = RESULT_NONE;
      this.errorMessage = '';
    },
  },
  components: {
    FormInput,
    Logo,
    LoadingModal,
  },
};
</script>
